import { useCallback } from 'react';
import map from 'lodash/map';
import { googleFetchPlaceDetails, googlePlacePredictions } from './utils';

export const useGoogleLocationApi = googleMapsSetting => {
  const googleAutocomplete = useCallback(async text => {
    const result = await googlePlacePredictions(text, googleMapsSetting.countries);
    return map(result, ({ description: label, place_id: id }) => ({
      label,
      id,
    }));
  }, [googleMapsSetting.countries]);

  const fetchPlaceDetails = useCallback((coordinates, googleMap) => {
    return googleFetchPlaceDetails(coordinates, googleMap).catch(console.warn);
  }, []);
  return { googleAutocomplete, fetchPlaceDetails };
};
